import 'styles/react-data-grid/react-data-grid-row.css';
import React, { ComponentProps } from 'react';
import { DragSource } from 'react-dnd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IFormatterProps } from '../../../../@types/workspaceTypes';
import { Tooltip } from '@fluentui/react-components';
import { IEditableDataGridFormatter } from '../../../../@types/editableDataGridTypes';
import { useFullUserDetails } from '../../../../utils/hooks';
import { DragTitle } from '../../../CellFormatters/util';

type IRowMoveCellProps = IFormatterProps<{ id?: number; uuid?: string }> & {
  showTooltip?: boolean;
};

const RowMoveCell = (
  props: IRowMoveCellProps & {
    connectDragSource: Function;
    connectDragPreview: Function;
    isDragging: boolean;
    isRowHovered?: boolean;
  }
) => {
  const { connectDragSource, dependentValues } = props;

  const isSelected =
    props.dependentValues.cellMetaData?.selected?.idx === 0 &&
    props.dependentValues.cellMetaData?.selected?.rowIdx === props.rowIdx;

  //If there's no id/uuid on the row, should not be sortable (I.e. expecting it is the 'blank' row at the end, which shouldn't be movable).
  if (!(dependentValues.rowData?.id || dependentValues.rowData?.uuid)) return null;

  const content = (
    <div className="rdg-row-index">
      {props.rowIdx + 1}{' '}
      {isSelected ? (
        <FontAwesomeIcon
          icon={'grip-horizontal'}
          color={'grey'}
          style={{ marginTop: '5px', display: 'inline-block' }}
        />
      ) : null}
    </div>
  );

  if (props.showTooltip ?? true) {
    return connectDragSource(
      <div>
        <Tooltip content={<DragTitle />} relationship="label">
          {content}
        </Tooltip>
      </div>
    );
  }
  return connectDragSource(content);
};

/**
 * Variant of RowMoveCell when the user does not have permission to re-order rows.
 */
const RowNoMoveCell = (props: IRowMoveCellProps) => {
  return <div className="rdg-row-index">{props.rowIdx + 1}</div>;
};

function collect(connect: any, monitor: any) {
  return {
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
    connectDragPreview: connect.dragPreview(),
  };
}

const rowIndexSource = {
  beginDrag(props: IFormatterProps) {
    return { idx: props.rowIdx, data: props.dependentValues };
  },
  endDrag(props: IFormatterProps) {
    return { idx: props.rowIdx, data: props.dependentValues };
  },
};

const DragRowMoveCell = DragSource('Row', rowIndexSource, collect)(RowMoveCell) as unknown as typeof RowMoveCell;

export default (props: IRowMoveCellProps) => {
  const fullUserDetails = useFullUserDetails();
  const allowLineSort = fullUserDetails?.companyUser?.allowLineSorting;

  return allowLineSort ? <DragRowMoveCell {...props} /> : <RowNoMoveCell {...props} />;
};
